import { People } from '~/services/Http';

export const getNextAnnouncement = (
  visibleAnnouncement: People.CompanyPostDto | undefined,
  announcements: People.CompanyPostDto[],
): People.CompanyPostDto => {
  if (!visibleAnnouncement) {
    return announcements[0];
  }

  const visibleAnnouncementIndex = announcements.indexOf(visibleAnnouncement);

  return announcements[(visibleAnnouncementIndex + 1) % announcements.length];
};
